import { Button, Card, Typography } from "@mui/material";
import { Check, Search } from "@mui/icons-material";
import { useEffect, useReducer, useRef, useState } from "react";
import Form, { SectionTitle } from "../components/Form";
import FormFooter from "../components/FormFooter";
import useFetch from "../hooks/useFetch";
import TextBoxGroup from "./../components/TextBoxGroup";
import AppDialog from "./../components/AppDialog";
import useMasterData from "../hooks/useMasterData";
import { ValidateSite } from "../validation/schemas/SiteSchema";
import { DETAILS_APIS } from "../common/apis";
import { NewIcon } from "../icons/ButtonIcons";
import { useRoot, useToast, useUser } from "../rootContext";
import { getStartLetter } from "../utils";
import ManageSite from "../features/quick-details/manage/manage-site/ManageSite";
import { useWindowPopups } from "../components/useWindowPopups";
import { FormActions } from "../components/Form";
import ConfirmModal from "../components/ConfirmModal";

function EditSite({
  productId,
  customerId,
  customer,
  siteId,
  registrationDone,
  cancel,
  handleSearchTree,
  setExpandTreeData,
  startLetter
}) {

  const [data, dispatch] = useReducer(SiteReducer, { SiteExportOptionId: 1, });

  const user = useUser();
  const { CanDoDataMaintenance, CanAdministrate, CanEvaluate } = useRoot();
  const { get, post } = useFetch();
  const { getMasterData } = useMasterData();
  const { showToast, showErrorToast } = useToast();


  const [dropdownData, setDropdownData] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [editCheck, setEditCheck] = useState(false);
  const [openManagement, setOpenManagement] = useState(false);
  const [localData, setLocalData] = useState({});
  const [resp10, setResp10] = useState(false);
  const [pcIndex, setPCIndex] = useState(0);
  const [dialog, setDialog] = useState({
    title: "",
    message: "",
    actionName: "",
    open: false,
    width: "",
  });
  const didRun = useRef(false);

  const handleUpdateSite = async () => {
    let result = await post(DETAILS_APIS.UPDATE_SITE, {
      Site: data.Site,
      CustomerId: customerId || localData?.CustomerId,
      UserId: user.UserId,
      SiteId: data.SiteId,
      KalBranchId: data?.KalBranchId,
      ShowSiteName: !!data.ShowSiteName,
      ApplyKalBranchToAll: !!data.ApplyKALBranch,
      ExportOptionId: data.SiteExportOptionId,
      IsPredelivery: !!data.IsPredelivery,
      IsArchived: !!data.SiteArchived,

      MakeAllParked: data?.makeAllUnits === "1" ? true : false,
      MakeAllScrapped: data?.makeAllUnits === "2" ? true : false,
      MakeAllArchived: data?.makeAllUnits === "3" ? true : false,

      IsShowLimitsOnReport: !!data.IsShowLimitsOnReport || false,
      IsAutoCreated: false,
      OwnerUserId: data?.SiteCmsOwnerId || 0,

      Notes: data?.SiteNotes,

      ExportBlock: data?.LocationTaken,

      PostalAddressId: data?.a,
      PostalStreet1: data?.PostalStreet1,
      PostalStreet2: data?.PostalStreet2,
      PostalCity: data?.PostalCity,
      PostalState: data?.PostalState,
      PostalPostCode: data?.PostalPostCode,
      PostalCountry: data?.PostalCountry,

      PhysicalAddressId: data?.a,
      PhysicalStreet1: data?.PhysicalStreet1,
      PhysicalStreet2: data?.PhysicalStreet2,
      PhysicalCity: data?.PhysicalCity,
      PhysicalState: data?.PhysicalState,
      PhysicalPostCode: data?.PhysicalPostCode,
      PhysicalCountry: data?.PhysicalCountry,

      PrimaryContactId1: data?.PrimaryContactId1,
      PrimaryContactId2: data?.PrimaryContactId2,
      PrimaryContactId3: data?.PrimaryContactId3,

      Latitude: data?.SiteLatitude != null ? parseFloat(data.SiteLatitude) : null,
      Longitude: data?.SiteLongitude != null ? parseFloat(data.SiteLongitude) : null,
      LocationTaken: data?.LocationTaken,

      Screen: "Edit Site",
    });
    registrationDone && registrationDone(data.SampleNumber);
    if (result >= 0 || result?.length > 0) {

      const treeData = { ProductId: data?.ProductId, StartLetter: data?.StartLetter, CustomerId: data?.CustomerId, SiteId: data?.SiteId, refreshCheck: true }
      localStorage.setItem("tree-resp", JSON.stringify({ ...treeData }));
      window.dispatchEvent(new Event('storage'));

      setExpandTreeData && setExpandTreeData(treeData)
      handleSearchTree && handleSearchTree(treeData, null, true)
      cancel && cancel();
      if (window.location.pathname === '/add-new-site' || window.location.pathname === '/edit-site') {
        window.dispatchEvent(new Event('storage'));
        // localStorage.removeItem("edit-site");
        window.close()
      }
      return;
    }
    if (result === -10) {
      return setResp10(true);
    }
    if (result !== null && (result < 1 || result?.length < 1)) {
      return;
    }
    return;
  }

  const handleNewSite = async () => {
    let slIndex = 0;
    if (startLetter === undefined && localData?.StartLetter === undefined) {
      let name = (customer || localData?.Customer || "")?.trim();
      slIndex = Number(getStartLetter(name[0]));
    }
    else {
      slIndex = startLetter || localData?.StartLetter
    }

    let result = await post(DETAILS_APIS.ADD_SITE, {
      Site: data.Site,
      CustomerId: customerId || localData?.CustomerId,
      UserId: user.UserId,
      KalBranchId: data?.KalBranchId,
      ShowSiteName: !!data.ShowSiteName,
      ApplyKalBranchToAll: !!data.ApplyKALBranch,
      ExportOptionId: data.SiteExportOptionId,
      IsPredelivery: !!data.IsPredelivery,
      IsArchived: !!data.SiteArchived,

      MakeAllParked: data?.makeAllUnits === "1" ? true : false,
      MakeAllScrapped: data?.makeAllUnits === "2" ? true : false,
      MakeAllArchived: data?.makeAllUnits === "3" ? true : false,

      IsShowLimitsOnReport: !!data.IsShowLimitsOnReport || false,
      IsAutoCreated: false,
      OwnerUserId: data?.SiteCmsOwnerId || 0,

      Notes: data?.SiteNotes,

      ExportBlock: data?.LocationTaken,

      PostalAddressId: data?.a,
      PostalStreet1: data?.PostalStreet1,
      PostalStreet2: data?.PostalStreet2,
      PostalCity: data?.PostalCity,
      PostalState: data?.PostalState,
      PostalPostCode: data?.PostalPostCode,
      PostalCountry: data?.PostalCountry,

      PhysicalAddressId: data?.a,
      PhysicalStreet1: data?.PhysicalStreet1,
      PhysicalStreet2: data?.PhysicalStreet2,
      PhysicalCity: data?.PhysicalCity,
      PhysicalState: data?.PhysicalState,
      PhysicalPostCode: data?.PhysicalPostCode,
      PhysicalCountry: data?.PhysicalCountry,

      PrimaryContactId1: data?.PrimaryContactId1,
      PrimaryContactId2: data?.PrimaryContactId2,
      PrimaryContactId3: data?.PrimaryContactId3,

      Latitude: data?.SiteLatitude != null ? parseFloat(data.SiteLatitude) : null,
      Longitude: data?.SiteLongitude != null ? parseFloat(data.SiteLongitude) : null,

      LocationTaken: data?.LocationTaken,

      Screen: "New Site",
    });
    registrationDone && registrationDone(data.SampleNumber);

    if (result === -10) {
      return setResp10(true);
    }
    if (result >= 0 || result?.length > 0) {
      if (result > 0) {
        const treeData = { ProductId: productId || localData?.ProductId, StartLetter: slIndex, CustomerId: customerId || localData?.CustomerId, SiteId: result, refreshCheck: true }
        localStorage.setItem("tree-resp", JSON.stringify({ ...treeData }));
        window.dispatchEvent(new Event('storage'));

        setExpandTreeData && setExpandTreeData(treeData)
        handleSearchTree && handleSearchTree(treeData, null, true)
      }
      cancel && cancel();
      if (window.location.pathname === '/add-new-site' || window.location.pathname === '/edit-site') {
        // localStorage.removeItem("edit-site");
        window.close()
      }
      return;
    }
    if (result !== null && (result < 1 || result?.length < 1)) {
      return;
    }
    return;
  }

  const actions = {
    save: async function () {
      if (siteId || data?.SiteId) {
        setFormErrors({});
        ValidateSite(data).then(async function ({ data: req, errors }) {
          if (req) {
            handleUpdateSite()
          }
          if (errors) {
            setFormErrors(errors);
          }
        });
      } else {
        setFormErrors({});
        ValidateSite(data).then(async function ({ data: req, errors }) {
          if (req) {
            handleNewSite()
          }
          if (errors) {
            setFormErrors(errors);
          }
        });
      }
    },
    manage: async function () {
      setOpenManagement(true);
    },
  };


  const HandleNewWindow = (actionName) => {
    useWindowPopups(actionName, { selectCheck: true, ...data });
  }

  const handleContactClick = (actionName, id) => {
    HandleNewWindow(actionName);
    setPCIndex(id);
  };

  function handleViewPostal() {
    window.open(
      `https://maps.google.com/maps/place/${data.PostalStreet1 || data.PostalStreet2 || ""},${data?.PostalCity || ""},${data?.PostalPostCode || ""},${data?.PostalState || ""},${data?.PostalCountry || ""}`,
      "_blank"
    );
  }

  function handleViewPhysical() {
    window.open(
      `https://maps.google.com/maps/place/${data.PhysicalStreet1 || data.PhysicalStreet2 || ""},${data?.PhysicalCity || ""},${data?.PhysicalPostCode || ""},${data?.PhysicalState || ""},${data?.PhysicalCountry || ""}`,
      "_blank"
    );
  }

  function handleCopyToPostal() {
    dispatch({
      type: SiteActions.LOAD_DATA,
      payload: {
        ...data,
        PostalStreet1: data?.PhysicalStreet1 || "",
        PostalStreet2: data?.PhysicalStreet2 || "",
        PostalCity: data?.PhysicalCity || "",
        PostalPostCode: data?.PhysicalPostCode || "",
        PostalState: data?.PhysicalState || "",
        PostalCountry: data?.PhysicalCountry || "",
        key: Date.now(),
      },
    });
  }

  function handleCopyToPhysical() {
    dispatch({
      type: SiteActions.LOAD_DATA,
      payload: {
        ...data,
        PhysicalStreet1: data?.PostalStreet1 || "",
        PhysicalStreet2: data?.PostalStreet2 || "",
        PhysicalCity: data?.PostalCity || "",
        PhysicalPostCode: data?.PostalPostCode || "",
        PhysicalState: data?.PostalState || "",
        PhysicalCountry: data?.PostalCountry || "",
        key: Date.now(),
      }
    });
  }

  //handle logo upload
  const fileInputRef = useRef(null);

  function handleFileInputClick() {
    fileInputRef.current.accept = 'image/jpeg, image/png, image/webp';
    fileInputRef.current.click();
  }

  const deleteSiteLogoAlert = async () => {
    setDialog({
      title: "Delete Image",
      message: "Are you sure you want to delete this image?",
      actionName: "deleteClickAlert",
      open: true,
      width: "md",
    });
  };


  const deleteSiteLogo = async () => {
    let result = await get(`${DETAILS_APIS.DELETE_SITE_LOGO}?siteId=${data?.SiteId}`);

    setDialog({
      open: false,
    });

    if (result > 0) {
      showToast("Deleted Successfully!");
      dispatch({ type: SiteActions.LOAD_DATA, payload: { ...data, SiteLogo: null, HasLogo: false } });

    } else {
      showErrorToast("Failed to delete image!");
    }
  };

  const addSiteLogo = async (event) => {
    const file = event.target.files[0];  // Get the selected file
    // base64
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Data = reader.result;
        const img = base64Data?.split(",")[1];

        try {
          const payload = {
            SiteId: data.SiteId,
            imageLogo: img
          };

          let resp = await post(`${DETAILS_APIS.ADD_SITE_LOGO}`, payload);
          console.log('Image uploaded successfully:', resp);
          dispatch({ type: SiteActions.LOAD_DATA, payload: { ...data, SiteLogo: img, HasLogo: true } });

        }
        catch (error) {
          console.error('Error uploading image:');
        }
      };
      reader.readAsDataURL(file); // Convert file to base64
    }
  };

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;
    (async () => {
      if (siteId > 0) {
        let data = await get(`/details/site?siteId=${siteId}`);
        data.Users?.unshift({ UserId: 0, Username: "Default User" });
        setDropdownData(data || {});
        dispatch({ type: SiteActions.LOAD_DATA, payload: { ...data?.Site, key: Date.now(), } });
        setEditCheck(true)
      }
      else {
        let lData = JSON.parse(localStorage.getItem("edit-site"));
        if (lData !== null) {
          setLocalData(lData)
          if (lData?.SiteId > 0) {
            let data = await get(`/details/site?siteId=${lData?.SiteId}`);
            data.Users?.unshift({ UserId: 0, FullName: "Default User" });
            setDropdownData(data || {});
            dispatch({ type: SiteActions.LOAD_DATA, payload: { ...data?.Site, key: Date.now(), } });
            setEditCheck(true)
          }
          else {
            let masterData = await getMasterData("KalBranches,ExportOptions,Users,Countries");
            masterData.Users?.unshift({ UserId: 0, Username: "Default User" });
            setDropdownData(masterData || {});
          }
        }
      }

    })();
  }, [siteId]);

  const handleCloseButton = () => {
    // localStorage.removeItem("edit-site");
  }

  const eventCb = () => {

    const selectContact = JSON.parse(localStorage.getItem('search-contact-resp'));

    if (selectContact && pcIndex > 0) {
      const a = `PrimaryContactId${pcIndex}`;
      const b = `Username${pcIndex}`;

      dispatch({ type: SiteActions.LOAD_DATA, payload: { ...data, [a]: selectContact?.ContactId, [b]: selectContact?.Username, key: Date.now() } });
      setPCIndex(0);
      localStorage.removeItem('search-contact-resp')
    }
  }

  useEffect(function () {
    window.addEventListener("beforeunload", handleCloseButton);
    window.addEventListener("storage", eventCb);

    return function () {
      window.removeEventListener("beforeunload", handleCloseButton);
      window.removeEventListener("storage", eventCb);

    };
  });


  return (
    <Card sx={{ padding: 1 }}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={addSiteLogo}
        style={{ display: "none" }}
      />
      <Form
        sections={FormSections(
          data,
          CanAdministrate,
          resp10,
          dropdownData,
          handleFileInputClick,
          deleteSiteLogoAlert,
          handleContactClick,
          handleViewPhysical,
          handleCopyToPostal,
          handleViewPostal,
          handleCopyToPhysical,
          CanEvaluate
        )}
        data={data}
        spacing={2}
        dispatch={dispatch}
        errors={formErrors}
        key={data?.key}
      />

      <FormFooter
        footerText={`ProductId: ${productId || localData?.ProductId || ""}, CustomerId: ${customerId || localData?.CustomerId || ""
          }, SiteId: ${data?.SiteId || localData?.SiteId || ""} `}
        buttons={GetFormButtons(data, handleNewSite, actions, editCheck, CanDoDataMaintenance)} />

      <AppDialog
        open={openManagement}
        title={`Site Management  Site ${data.SiteId}`}
        maxWidth="100vw"
        handleClose={() => setOpenManagement(false)}
      >
        <ManageSite unit={data} />
      </AppDialog>

      <AppDialog
        open={dialog.open}
        handleClose={() =>
          setDialog((prevState) => ({
            ...prevState,
            open: false,
          }))
        }
        title={dialog.title}
        maxWidth={dialog.width}
      >
        <ConfirmModal
          handleClose={() => {
            setDialog((prevState) => ({
              ...prevState,
              open: false,
            }));
          }} alertAction={deleteSiteLogo}
          message={dialog.message}
          buttonText={"Yes"}
          buttonText2={"Cancel"}
        />
      </AppDialog>
    </Card>
  );
}

export default EditSite;

//edit dialog ended
const GetFormButtons = (data, handleNewSite, { save, manage }, editCheck, CanDoDataMaintenance) => [
  !!editCheck && {
    variant: "outlined",
    label: "Manage",
    onClick: manage,
  },
  !!editCheck && {
    variant: "outlined",
    label: "Save New",
    onClick: handleNewSite,
    startIcon: <NewIcon />,
  },
  {
    hidden: !CanDoDataMaintenance,
    variant: "contained",
    label: "Save",
    onClick: save,
    startIcon: <Check />,
  },
];

const FormSections = (
  data,
  CanAdministrate,
  resp10,
  dropdownData,
  handleFileInputClick,
  deleteSiteLogoAlert,
  handleContactClick,
  handleViewPhysical,
  handleCopyToPostal,
  handleViewPostal,
  handleCopyToPhysical,
  CanEvaluate,
) => {
  return [
    {
      xsCol: 12,
      fields: [
        {
          xsCol: 12,
          component: function () {
            return <Typography sx={{ color: "red" }}> {resp10 === true ? "Please provide a UNIQUE name for Site" : ".  "}</Typography>
          },
        },
        { name: "Site", label: "Name", xsCol: 9 },
        {
          name: "SiteArchived",
          label: "Archived - no website",
          type: "switch",
          xsCol: 3,
        },
        {
          name: "CustomerCmsOwnerId",
          label: "CMS Owner",
          type: "dropdown",
          xsCol: 4,
          selectOptions: (dropdownData.Users || []).map((x) => ({
            value: x.UserId,
            text: x.FullName,
          })),
        },
        {
          name: "KalBranchId",
          label: "Branch",
          type: "dropdown",
          xsCol: 4,
          selectOptions: (dropdownData.KalBranches || []).map((x) => ({
            value: x.BranchId,
            text: x.FullBranch,
          })),
        },
        {
          name: "ApplyKALBranch",
          label: "Apply KAL Branch to ALL Units for this Site",
          type: "switch",
          xsCol: 4,
        },
        {
          xsCol: 4,
          name: "Username1",
          component: function ({ id, value }) {
            const options = {
              label: "Primary1",
              id,
              value,
              readOnly: true,
              buttons: [
                {
                  onClick: () => handleContactClick("search-contact", 1),
                  icon: <Search />,
                },
              ],
            };
            return <TextBoxGroup {...options} />;
          },
        },
        {
          xsCol: 4,
          name: "Username2",
          component: function ({ id, value }) {
            const options = {
              label: "Primary2",
              id,
              value,
              readOnly: true,
              buttons: [
                {
                  onClick: () => handleContactClick("search-contact", 2),
                  icon: <Search />,
                },
              ],
            };
            return <TextBoxGroup {...options} />;
          },
        },
        {
          xsCol: 4,
          name: "Username3",
          //  name: "PrimaryContactId3",
          component: function ({ id, value }) {
            const options = {
              label: "Primary3",
              id,
              value,
              readOnly: true,
              buttons: [
                {
                  onClick: () => handleContactClick("search-contact", 3),
                  icon: <Search />,
                },
              ],
            };
            return <TextBoxGroup {...options} />;
          },
        },
        {
          name: "LocationTaken",
          label: "Date Taken",
          xsCol: 4,
          type: "datetime",
        },
        { name: "SiteLatitude", label: "Latitude (Negative Number)", xsCol: 4 },
        { name: "SiteLongitude", label: "Longitude (Positive Number)", xsCol: 4 },
        // !!editCheck && {
        //   component: function () {
        //     return (
        //       <>
        //         <Button sx={{ marginTop: "17px" }} variant="contained">
        //           Get Address
        //         </Button>
        //       </>
        //     );
        //   },
        // },
        // !!editCheck && {
        //   component: function () {
        //     return (
        //       <>
        //         <Button sx={{ marginTop: "17px" }} variant="contained">
        //           View
        //         </Button>
        //       </>
        //     );
        //   },
        // },
        {
          name: "makeAllUnits",
          label: "Apply to All Units in this Site:",
          type: "dropdown",
          xsCol: 4,
          selectOptions: [
            { value: "1", text: "Make ALL Units Parked -on website" },
            { value: "2", text: "Make ALL Units Scrapped -not on website" },
            { value: "2", text: "Make ALL Units Archived -no website" },
          ],
        },
        {
          name: "IsShowLimitsOnReport",
          label: "Show Test Limits on Report",
          type: "switch",
          xsCol: 3,
        },
        {
          xsCol: 12,
          component: function () {
            return <SectionTitle title="Additional Information" />;
          },
        },
        { name: "SiteNotes", label: "Comment", xsCol: 12, type: "textarea" },
      ],
    },
    {
      xsCol: 6,
      fields: [
        { name: "PhysicalStreet1", label: "Physical Address 1", xsCol: 12 },
        { name: "PhysicalStreet2", label: "Address 2", xsCol: 12 },
        { name: "PhysicalCity", label: "Town", xsCol: 12 },
        { name: "PhysicalState", label: "State", xsCol: 6 },
        { name: "PhysicalPostCode", label: "Postcode", xsCol: 6 },
        {
          name: "PhysicalCountry",
          label: "Country",
          type: "dropdown",
          xsCol: 12,
          selectOptions: (dropdownData.Countries || []).map((x) => ({
            value: x.Country,
            text: x.Country,
          })),
        },
        {
          xsCol: 6,
          component: function () {
            return <Button onClick={handleViewPhysical}>View Physical</Button >;
          },
        },
        {
          xsCol: 6,
          component: function () {
            return <Button onClick={handleCopyToPostal}>Copy to Postal</Button >;
          },
        },
      ],
    },
    {
      xsCol: 6,
      fields: [
        { name: "PostalStreet1", label: "Postal Address 1", xsCol: 12 },
        { name: "PostalStreet2", label: "Address 2", xsCol: 12 },
        { name: "PostalCity", label: "Town", xsCol: 12 },
        { name: "PostalState", label: "State", xsCol: 6 },
        { name: "PostalPostCode", label: "Postcode", xsCol: 6 },
        {
          name: "PostalCountry",
          label: "Country",
          type: "dropdown",
          selectOptions: (dropdownData.Countries || []).map((x) => ({
            value: x.Country,
            text: x.Country,
          })),
          xsCol: 12,
        },
        {
          xsCol: 6,
          component: function () {
            return <Button onClick={handleViewPostal}>View Postal</Button >;
          },
        },
        {
          xsCol: 6,
          component: function () {
            return <Button onClick={handleCopyToPhysical}>Copy to Physical</Button >;
          },
        },
      ],
    },
    CanAdministrate && {
      xsCol: 12,
      fields: [
        {
          variant: "outlined",
          label: "Report Logo",
          component: function () {
            return (
              data?.HasLogo === true
                ? <Button
                  onClick={deleteSiteLogoAlert}
                  disabled={!CanEvaluate}
                >
                  Remove
                </Button>
                : <Button
                  // startIcon={<ReportLogoIcon />}
                  variant="outlined"
                  onClick={handleFileInputClick}
                  disabled={!CanEvaluate}
                >
                  Report Logo
                </Button>
            );
          },
        },
        {
          variant: "outlined",
          label: "Report Logo",
          component: function () {
            return (
              data?.HasLogo === true
                ? <Typography style={{ marginTop: 7 }}>
                  Site logo is being used
                </Typography>
                : <Typography style={{ marginTop: 7 }}>
                  Image requirements: JPEG, 100px to 1000px high, e.g. 200 x 100
                </Typography>
            );
          },
        },
        {
          variant: "outlined",
          label: "Report Logo",
          component: function () {
            return (
              data?.HasLogo === true
                ?
                <>
                  <img src={"data:image/png;base64," + data?.SiteLogo}
                    alt="Site Logo"
                    height="100"
                  />
                </>
                : <></>
            );
          },
        },
      ],
    },
    {
      xsCol: 12,
      fields: [
        {
          name: "SiteBlockEvaluationsFrom",
          label: "Limited From",
          xsCol: 3,
          type: "date",
        },
        {
          name: "SiteExportOptionId",
          label: "Exports",
          type: "dropdown",
          xsCol: 3,
          required: true,
          selectOptions: (dropdownData.ExportOptions || []).map((x) => ({
            value: x.ExportOptionId,
            text: x.ExportOption,
          })),
        },
      ],
    },
  ];
};


export const SiteActions = {
  LOAD_DATA: "load-data",
};

function SiteReducer(state, action) {
  if (action.type === FormActions.INPUT_CHANGED) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  if (action.type === SiteActions.LOAD_DATA) {
    return action.payload;
  }
  return state;
}
